export default __webpack_public_path__ + "487eff5f735f147a3e2a050dd2e8b31c.svg";